import { SESSION_STORAGE_VARIABLES, sessionStorageManager } from '@app/services/storageManager';

export const saveAlertNameInStorage = (key?: string) => {
  if (!key) {
    return;
  }
  const storageData = sessionStorageManager.getItem(SESSION_STORAGE_VARIABLES.DISMISSED_ALERTS) ?? {};
  storageData[key] = 'true';

  sessionStorageManager.setItem(SESSION_STORAGE_VARIABLES.DISMISSED_ALERTS, storageData);
};
